import { MoveableBookFeature } from './moveable-book-feature';
import { Position } from './position';

export class TextBox extends MoveableBookFeature {

    content: string;
    isHighlighted: boolean;
    isSelected: boolean;
    isEndOfSelection: boolean;
    zIndex = 1;

    static createEmptyTextBox(): TextBox {
        const textBox = new TextBox();
        textBox.position = Position.createEmptyPosition();

        return textBox;
    }

    getEndpointName(): string {
        throw new Error('No Endpoint defined');
    }
}
